import type { ReactNode } from 'react';

import { SiteFooter } from './SiteFooter.js';
import { SiteNav } from './SiteNav.js';
import { Stamp } from './Stamp.js';

interface LegalShellProps {
  stamp: string;
  title: string;
  lastUpdated: string;
  intro?: ReactNode;
  children: ReactNode;
}

export function LegalShell({ stamp, title, lastUpdated, intro, children }: LegalShellProps) {
  return (
    <>
      <SiteNav />
      <main>
        <article className="mx-auto max-w-3xl px-6 pb-24 pt-20 lg:pt-28">
          <header className="mb-10 border-b border-[var(--border-subtle)] pb-8">
            <p className="mb-4 inline-block">
              <Stamp>{stamp}</Stamp>
            </p>
            <h1 className="font-serif text-[36px] font-medium leading-[1.1] tracking-[-0.02em] text-[var(--ink-primary)] sm:text-[44px]">
              {title}
              <span className="text-[var(--accent-saffron)]">.</span>
            </h1>
            <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--ink-tertiary)]">
              última atualização · {lastUpdated}
            </p>
            {intro && (
              <div className="mt-6 font-serif text-[17px] leading-[1.55] text-[var(--ink-secondary)]">
                {intro}
              </div>
            )}
          </header>

          <div className="prose-legal font-sans text-[15px] leading-relaxed text-[var(--ink-secondary)]">
            {children}
          </div>

          <footer className="mt-16 border-t border-[var(--border-subtle)] pt-6">
            <p className="font-sans text-xs italic text-[var(--ink-tertiary)]">
              Dúvidas sobre este documento? Escreva pra{' '}
              <a
                href="mailto:contato@smartapply.com.br"
                className="text-[var(--ink-secondary)] underline underline-offset-4 hover:text-[var(--ink-primary)]"
              >
                contato@smartapply.com.br
              </a>
              .
            </p>
          </footer>
        </article>
      </main>
      <SiteFooter />
    </>
  );
}
